export class ConciliacaoMovimento {

  conciliacaoId: number = 0;  // Identificador único da conciliacao

  tipo: string = ''; // Tipo de transação (débito ou crédito ou outros)

  dataPostagem: Date = new Date();       // Data da transação

  valor: number = 0;            // Valor da transação

  nome: string = '';             // Nome do estabelecimento ou descrição

  descricao?: string = '';       // Informações adicionais (opcional)

  statusConciliacao: number = 0; //(0 = NãoConciliada, 1 = Conciliada, 2 = Ignorada);

  saguiClienteId: number = 0; // id de saguicliente

  caixaId: number = 0; // identificador do caixa relacionado

  fitid: string = ''; // Identificador único da transação (FITID)

  //propriedades para validacao do ofx
  codigoBancoOFX: number = 0;
  agenciaOFX: string = '';
  contaCorrenteOFX: string = '';

}
